import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  entity_identification_bic: {
    name: "Broker's BIC"
  },
  entity_identification_lei: {
    name: "Broker's LEI"
  },
  entity_name: {
    name: "Broker's Name"
  }
};

export function PrimeBrokerFund({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.PRIME_BROKE_FUNDS,
    onChangeFund,
    schema: schema.PRIME_BROKE_FUNDS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.PRIME_BROKE_FUNDS?.field_names || [],
    columnLables,
    tableName: 'PRIME_BROKE_FUNDS',
    order: 38 as any,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn
  });

  return (
    <Table
      id="fca-reporttables-prime-broker-fund-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
